/**
 * Pure string handling for authenticator-app codes and setup keys.
 * No Amplify/Cognito dependency, so this stays unit-testable on its own.
 */

/**
 * Authenticator apps display "123 456" and password managers paste it that
 * way, but Cognito rejects anything that is not six bare digits.
 */
export function normalizeTotpCode(raw: string): string {
  return raw.replace(/\D/g, '')
}

export function isCompleteTotpCode(raw: string): boolean {
  return normalizeTotpCode(raw).length === 6
}

/**
 * Base32 setup key in groups of four. Typing 52 unbroken characters into a
 * phone is where manual enrolment goes wrong; the grouping is what every
 * other provider shows, and authenticator apps ignore the spaces.
 */
export function formatSetupKey(secret: string): string {
  return (secret.match(/.{1,4}/g) ?? []).join(' ')
}
